export default function FormatDate(date) {
    if (!(date instanceof Date)) throw new Error("Not a date");
    
    const year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return `${year}-${month}-${day}`;
}


// WEBPACK FOOTER //
// ./src/js/FormatDate.js